export class CenterData {
    constructor(id, title, phone_num_1st, services, address, homepage) {
        this.id = id;
        this.title = title;
        this.phone_num_1st = phone_num_1st;
        this.services = services;
        this.address = address;
        this.homepage = homepage;
    }

    static fromJson(json) {
        return new CenterData(
            json.id,
            json.title,
            json.phone_num_1st,
            json.services,
            json.address,
            json.homepage
        );
    }

    static fromJsonArray(jsonArray) {
        return jsonArray.map(json => CenterData.fromJson(json));
    }

    toString() {
        return this.title;
    }
}
